export default "__VITE_ASSET__D$OpRnqo__"